module.exports = __webpack_public_path__ + "img/Vector_50_9112.e6941881.png";